import { useEffect, useState } from "react"

/**
 * A simple hook for using `URL.createObjectURL(obj)` with a proper cleanup.
 * @param obj A `Blob` or `MediaSource`.
 * @returns The `URL` for the given parameter.
 */
export function useObjectURL(obj: Blob | MediaSource) {
  const [objURL, setObjURL] = useState<string>("")

  useEffect(() => {
    let url: string | undefined
    try {
      url = URL.createObjectURL(obj)
      setObjURL(url)
    } catch (error) {
      url = undefined
      setObjURL("")
    }

    return () => {
      if (typeof url === "string") {
        URL.revokeObjectURL(url)
      }
    }
  }, [obj])

  return objURL
}
